import matchHeight from "../../plugins/jquery.matchHeight.js";

$(".js-align-height").matchHeight();
